module.exports = __webpack_public_path__ + "img/26be.ad6934e.svg";